import React, { useContext, useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import AppLayout from "./Components/AppLayout/AppLayout";
import About from "./Pages/About/About";
import ContactUs from "./Pages/ContactUs/ContactUs";
import InternalServer from "./Pages/Others/InternalServer";
import NotFound from "./Pages/Others/NotFound";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import TermsConditions from "./Pages/TermsConditions/TermsConditions";
import Home from "./Pages/Home/Home";
import StateSpecific from "./Pages/StateSpecific/StateSpecific";
import LoadTemplate from "./Pages/LoadTemplate/LoadTemplate";
import SkipSelectState from "./Pages/SelectStateSpecificTemplate/SkipSelectState";
import TemplateDataContext from "./Contexts/TemplateData.context";
import { ROOT_PATH, templateActionEnum } from "./Config/Constants";
import TemplateLayout from "./Components/AppLayout/TemplateLayout";
import SetTemplateDesign from "./Components/SetTemplate/SetTemplateDesign";
import SignIn from "./Pages/SignIn/SignIn";
import SignUp from "./Pages/SignUp/SignUp";
import Plans from "./Pages/Plans/Plans";
import Checkout from "./Pages/Checkout/Checkout";
import ForgetPassword from "./Pages/ForgetPassword/ForgetPassword";
import ConfirmationPage from "./Pages/ConfirmationPage/ConfirmationPage";
import ResetPassword from "./Pages/ResetPassword/ResetPassword";
import SsoTransfer from "./Pages/SSOTransfer/sso-transfer";
import SignOut from "./Pages/SignOut/SignOut";

import { GoogleOAuthProvider } from "@react-oauth/google";
import { getGoogleClientId } from "./Util/general-config";

const AppRoutes = () => {
  /* Reset THE Toast Modal on page refresh and reload */
  const location = useLocation();
  const currentEnv = `${process.env.REACT_APP_ENVIRONMENT}`;
  const currEnv = `${process.env.NODE_ENV}`;

  console.log("current-REACT_APP_ENVIRONMENT ::", currentEnv);
  //console.log("current-NODE_ENV ::", currEnv);
  const { dispatch } = useContext(TemplateDataContext);
  useEffect(() => {
    dispatch({ type: templateActionEnum.SET_ERROR, payload: { show: false } });
    return () => {};
  }, [dispatch, location]);

  return (
    <Routes>
      <Route path={`/${ROOT_PATH}`} element={<AppLayout mainComponent={<Home />} />} />
      <Route path={`/${ROOT_PATH}/:templateType`} element={<TemplateLayout mainComponent={<LoadTemplate />} />} />
      <Route
        path={`/${ROOT_PATH}/:templateType/:template`}
        element={<TemplateLayout mainComponent={<SetTemplateDesign />} />}
      />
      <Route
        path={`/${ROOT_PATH}/:templateType/:template/:stepName`}
        element={<TemplateLayout mainComponent={<SetTemplateDesign />} />}
      />
      <Route
        path={`/${ROOT_PATH}/state-specific/:templateType`}
        element={
          <AppLayout
            mainComponent={
              <SkipSelectState>
                <StateSpecific />
              </SkipSelectState>
            }
          />
        }
      />
      <Route
        path={`/${ROOT_PATH}/state-specific/:templateType/:state`}
        element={<TemplateLayout mainComponent={<LoadTemplate />} />}
      />
      <Route
        path={`/${ROOT_PATH}/state-specific/:templateType/:state/:template`}
        element={<TemplateLayout mainComponent={<SetTemplateDesign />} />}
      />
      <Route
        path={`/${ROOT_PATH}/state-specific/:templateType/:state/:template/:stepName`}
        element={<TemplateLayout mainComponent={<SetTemplateDesign />} />}
      />
      <Route path={`/${ROOT_PATH}/about`} element={<AppLayout mainComponent={<About />} />} />
      <Route path={`/${ROOT_PATH}/privacy-policy`} element={<AppLayout mainComponent={<PrivacyPolicy />} />} />
      <Route path={`/${ROOT_PATH}/terms-conditions`} element={<AppLayout mainComponent={<TermsConditions />} />} />
      <Route path={`/${ROOT_PATH}/contactUs`} element={<AppLayout mainComponent={<ContactUs />} />} />
      <Route path={`/${ROOT_PATH}/Plans`} element={<AppLayout mainComponent={<Plans />} />} />
      <Route path={`/${ROOT_PATH}/checkout`} element={<AppLayout mainComponent={<Checkout />} />} />
      <Route path={`/${ROOT_PATH}/forget-password`} element={<AppLayout mainComponent={<ForgetPassword />} />} />
      <Route path={`/${ROOT_PATH}/confirmation`} element={<AppLayout mainComponent={<ConfirmationPage />} />} />
      <Route path={`/${ROOT_PATH}/reset-password`} element={<AppLayout mainComponent={<ResetPassword />} />} />
      <Route path={`/${ROOT_PATH}/sso-transfer`} element={<SsoTransfer />} />
      <Route path={`/${ROOT_PATH}/sign-out`} element={<SignOut />} />
      {/* <Route path={`/${ROOT_PATH}/sign-up`} element={<AppLayout mainComponent={<SignUp />} />} /> */}
      {/* <Route path={`/${ROOT_PATH}/sign-in`} element={<AppLayout mainComponent={<SignIn />} />} /> */}

      <Route
        path={`/${ROOT_PATH}/sign-in`}
        element={
          <AppLayout
            mainComponent={
              <GoogleOAuthProvider clientId={getGoogleClientId()}>
                <SignIn />
              </GoogleOAuthProvider>
            }
          />
        }
      >
        <Route
          path={`/${ROOT_PATH}/sign-in`}
          element={
            <GoogleOAuthProvider clientId={getGoogleClientId()}>
              <SignIn />
            </GoogleOAuthProvider>
          }
        />
      </Route>

      <Route
        path={`/${ROOT_PATH}/sign-up`}
        element={
          <AppLayout
            mainComponent={
              <GoogleOAuthProvider clientId={getGoogleClientId()}>
                <SignUp />
              </GoogleOAuthProvider>
            }
          />
        }
      >
        <Route
          path={`/${ROOT_PATH}/sign-up`}
          element={
            <GoogleOAuthProvider clientId={getGoogleClientId()}>
              <SignUp />
            </GoogleOAuthProvider>
          }
        />
      </Route>

      {/* Other Routes Please Do Not Create Any Routes After This Line */}
      <Route path="/500" element={<InternalServer />} />
      <Route path="*" element={<NotFound />} />
      <Route path="/" element={<Navigate to={`/${ROOT_PATH}`} />} />
    </Routes>
  );
};

export default AppRoutes;
